export default class SDVDeleteModule {

  constructor(stackId = null, deleteRoute = "/delete_additional_image") {  
    this.gradingFormStackId = stackId;   
    this.deleteRoute = deleteRoute;   
}
    
      setStackId(stackId) {
        this.gradingFormStackId = stackId; 
      }


    deleteSDVImage(e) {
        e.preventDefault();
        const button = e.currentTarget;
        const action = button.getAttribute("data-action"); 
        let deleteRoute = this.deleteRoute;

        if (action.includes("additional_grading_form#")) {
            deleteRoute = "/delete_additional_image"; // Grading form route
        } else if (action.includes("additional_adjudication#")) {
            deleteRoute = "/delete_additional_adj_image"; // Adjudication route
        }
        const parentDiv = event.target.closest(".image-container, .file-container");
        const confirmation = confirm("Are you sure you want to delete this file?");
        if (confirmation) {
          const fileName = e.currentTarget.getAttribute("data-filename");
          const fileKey = e.currentTarget.getAttribute("data-key");
          const fileUrl = e.currentTarget.getAttribute("data-url");
          const blob_id = e.currentTarget.getAttribute("data-id");
       
          fetch(deleteRoute, {
            method: "post",
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "X-CSRF-Token": document.head
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
            },
            body: JSON.stringify({
              image_url: fileName,
              stack_id: this.gradingFormStackId,
              image_array: fileKey,
              url: fileUrl,
              blob_id: blob_id,
            }),
          })
            .then((response) => {
              if (response.ok) {
                location.reload();
              } else {
                console.error("Failed to delete image");
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    
    }

    